"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.defaultFormatLink = exports.defaultControlsConfig = exports.XSS_PATTERN = exports.WHCM_DISABLED_ITEM_COLOR = exports.TABLE_SELECTED_CELL_BACKGROUND_COLOR = exports.TABLE_POPOVER_SEPARATOR_MARGIN = exports.TABLE_POPOVER_SEPARATOR_HEIGHT = exports.TABLE_POPOVER_SEPARATOR_COLOR = exports.TABLE_POPOVER_LIST_PADDING_VERTICAL = exports.TABLE_POPOVER_LIST_PADDING_HORIZONTAL = exports.TABLE_POPOVER_ITEM_TEXT_COLOR = exports.TABLE_POPOVER_ITEM_PADDING = exports.TABLE_POPOVER_ITEM_OUTLINE_WIDTH = exports.TABLE_POPOVER_ITEM_HIGHLIGHT_OUTLINE_COLOR = exports.TABLE_POPOVER_ITEM_HIGHLIGHT_BACKGROUND_COLOR = exports.TABLE_POPOVER_ITEM_FONT_SIZE = exports.TABLE_POPOVER_ITEM_DISABLED_TEXT_OPACITY = exports.TABLE_POPOVER_ITEM_DISABLED_TEXT_COLOR = exports.TABLE_POPOVER_ITEM_BORDER_RADIUS = exports.TABLE_POPOVER_ITEM_BACKGROUND_COLOR = exports.TABLE_HEADER_BACKGROUND_COLOR = exports.TABLE_BORDER_COLOR = exports.OUTLINE_WIDTH = exports.HIGHLIGHT_DEFAULT_TEXT_COLOR_HEX = exports.FOOTER_BORDER_RADIUS = exports.COLOR_POPOVER_TEXT_WIDTH = exports.COLOR_POPOVER_TEXT_COLOR = exports.COLOR_POPOVER_BADGE_RADIUS = exports.COLOR_POPOVER_BADGE_MARGIN_RIGHT = exports.COLOR_BADGE_WIDTH = exports.COLOR_BADGE_HEIGHT = void 0;

var _react = _interopRequireDefault(require("react"));

var _text = require("../text");

var _core = require("@emotion/core");

var OUTLINE_WIDTH = 2;
exports.OUTLINE_WIDTH = OUTLINE_WIDTH;
var TABLE_POPOVER_ITEM_PADDING = 'S200';
exports.TABLE_POPOVER_ITEM_PADDING = TABLE_POPOVER_ITEM_PADDING;
var TABLE_POPOVER_ITEM_BORDER_RADIUS = 'R100';
exports.TABLE_POPOVER_ITEM_BORDER_RADIUS = TABLE_POPOVER_ITEM_BORDER_RADIUS;
var TABLE_POPOVER_ITEM_FONT_SIZE = 'T200';
exports.TABLE_POPOVER_ITEM_FONT_SIZE = TABLE_POPOVER_ITEM_FONT_SIZE;
var TABLE_POPOVER_ITEM_TEXT_COLOR = 'neutral90';
exports.TABLE_POPOVER_ITEM_TEXT_COLOR = TABLE_POPOVER_ITEM_TEXT_COLOR;
var TABLE_POPOVER_ITEM_DISABLED_TEXT_COLOR = 'neutral10';
exports.TABLE_POPOVER_ITEM_DISABLED_TEXT_COLOR = TABLE_POPOVER_ITEM_DISABLED_TEXT_COLOR;
var TABLE_POPOVER_ITEM_BACKGROUND_COLOR = 'neutral0';
exports.TABLE_POPOVER_ITEM_BACKGROUND_COLOR = TABLE_POPOVER_ITEM_BACKGROUND_COLOR;
var TABLE_POPOVER_ITEM_HIGHLIGHT_BACKGROUND_COLOR = 'primary05';
exports.TABLE_POPOVER_ITEM_HIGHLIGHT_BACKGROUND_COLOR = TABLE_POPOVER_ITEM_HIGHLIGHT_BACKGROUND_COLOR;
var TABLE_POPOVER_ITEM_HIGHLIGHT_OUTLINE_COLOR = 'primary70';
exports.TABLE_POPOVER_ITEM_HIGHLIGHT_OUTLINE_COLOR = TABLE_POPOVER_ITEM_HIGHLIGHT_OUTLINE_COLOR;
var TABLE_POPOVER_ITEM_OUTLINE_WIDTH = 2;
exports.TABLE_POPOVER_ITEM_OUTLINE_WIDTH = TABLE_POPOVER_ITEM_OUTLINE_WIDTH;
var TABLE_BORDER_COLOR = 'neutral50';
exports.TABLE_BORDER_COLOR = TABLE_BORDER_COLOR;
var TABLE_HEADER_BACKGROUND_COLOR = 'neutral05';
exports.TABLE_HEADER_BACKGROUND_COLOR = TABLE_HEADER_BACKGROUND_COLOR;
var TABLE_POPOVER_LIST_PADDING_VERTICAL = 'S200';
exports.TABLE_POPOVER_LIST_PADDING_VERTICAL = TABLE_POPOVER_LIST_PADDING_VERTICAL;
var TABLE_POPOVER_LIST_PADDING_HORIZONTAL = 'S200';
exports.TABLE_POPOVER_LIST_PADDING_HORIZONTAL = TABLE_POPOVER_LIST_PADDING_HORIZONTAL;
var WHCM_DISABLED_ITEM_COLOR = 'grayText';
exports.WHCM_DISABLED_ITEM_COLOR = WHCM_DISABLED_ITEM_COLOR;
var TABLE_SELECTED_CELL_BACKGROUND_COLOR = 'primary10';
exports.TABLE_SELECTED_CELL_BACKGROUND_COLOR = TABLE_SELECTED_CELL_BACKGROUND_COLOR;
var TABLE_POPOVER_ITEM_DISABLED_TEXT_OPACITY = 0.38;
exports.TABLE_POPOVER_ITEM_DISABLED_TEXT_OPACITY = TABLE_POPOVER_ITEM_DISABLED_TEXT_OPACITY;
var TABLE_POPOVER_SEPARATOR_COLOR = 'neutral50';
exports.TABLE_POPOVER_SEPARATOR_COLOR = TABLE_POPOVER_SEPARATOR_COLOR;
var TABLE_POPOVER_SEPARATOR_MARGIN = 8;
exports.TABLE_POPOVER_SEPARATOR_MARGIN = TABLE_POPOVER_SEPARATOR_MARGIN;
var TABLE_POPOVER_SEPARATOR_HEIGHT = 1;
exports.TABLE_POPOVER_SEPARATOR_HEIGHT = TABLE_POPOVER_SEPARATOR_HEIGHT;
var COLOR_POPOVER_TEXT_COLOR = 'neutral70';
exports.COLOR_POPOVER_TEXT_COLOR = COLOR_POPOVER_TEXT_COLOR;
var COLOR_BADGE_HEIGHT = 20;
exports.COLOR_BADGE_HEIGHT = COLOR_BADGE_HEIGHT;
var COLOR_BADGE_WIDTH = 20;
exports.COLOR_BADGE_WIDTH = COLOR_BADGE_WIDTH;
var COLOR_POPOVER_BADGE_MARGIN_RIGHT = 10;
exports.COLOR_POPOVER_BADGE_MARGIN_RIGHT = COLOR_POPOVER_BADGE_MARGIN_RIGHT;
var COLOR_POPOVER_BADGE_RADIUS = 'R1000';
exports.COLOR_POPOVER_BADGE_RADIUS = COLOR_POPOVER_BADGE_RADIUS;
var COLOR_POPOVER_TEXT_WIDTH = 328;
exports.COLOR_POPOVER_TEXT_WIDTH = COLOR_POPOVER_TEXT_WIDTH;
var HIGHLIGHT_DEFAULT_TEXT_COLOR_HEX = '#FFFFFF';
exports.HIGHLIGHT_DEFAULT_TEXT_COLOR_HEX = HIGHLIGHT_DEFAULT_TEXT_COLOR_HEX;
var FOOTER_BORDER_RADIUS = '0 0 8px 8px';
exports.FOOTER_BORDER_RADIUS = FOOTER_BORDER_RADIUS;
var XSS_PATTERN = /(<(\b(?:(?:body|script|svg|iframe|embed|object|link)\b|\w+:\w+))\b[^>]*>.*?<\/\2>|<.*?on\w+=.*?>|<.*?(style="[^"]*expression[^"]*").*?>)/gi;
exports.XSS_PATTERN = XSS_PATTERN;
var defaultProps = {
  'aria-label': 'Rich Text Editor',
  clipboardNotSupportedMessage: (0, _core.jsx)(_text.Text, null, "Browser binary clipboard operations support not detected. To change preferences in Firefox, visit ", (0, _core.jsx)("strong", null, "about:config"), " and enable", ' ', (0, _core.jsx)("strong", null, "dom.events.asyncClipboard.clipboardItem"), " and", ' ', (0, _core.jsx)("strong", null, "dom.events.testing.asyncClipboard"), " preferences."),
  defaultContent: '',
  defaultHeight: 320,
  imageModalLocalization: {},
  tablePopoverLocalization: {},
  tableModalLocalization: {},
  tableEditModalLocalization: {},
  fontColorPopoverLocalization: {},
  highlightPopoverLocalization: {},
  keyboardShortcutsAltText: 'Press the alternate plus 0 key on Windows or option plus 0 key on Mac to open keyboard shortcuts.',
  keyboardShortcutsHintText: 'Open Keyboard Shortcuts (Mac: Option + 0 | Windows: Alt + 0)',
  keyboardShortcutsLocalization: {
    'aria-label': 'Keyboard shortcut commands for Windows and MacOS'
  },
  linkModalLocalization: {},
  onBlur: function onBlur() {
    return null;
  },
  onFocus: function onFocus() {
    return null;
  },
  showToolbar: true
};
exports.defaultProps = defaultProps;

var defaultFormatLink = function defaultFormatLink(link) {
  var startsWithSlash = /^\//gm;
  var startsWithHash = /^#/gm;
  var startsWithScheme = /^[a-z]+:/gm;
  var startsWithJavascript = /^javascript:/gim;
  if ((startsWithSlash.test(link) || startsWithHash.test(link) || startsWithScheme.test(link)) && !startsWithJavascript.test(link)) return link;
  return 'https://' + link;
};

exports.defaultFormatLink = defaultFormatLink;
var defaultControlsConfig = {
  heading: {
    title: 'Heading',
    showInToolbar: true,
    options: {
      levels: [1, 2, 3, 4]
    }
  },
  paragraph: {
    title: 'Paragraph',
    showInToolbar: true
  },
  bold: {
    title: 'Make Bold',
    showInToolbar: true
  },
  italic: {
    title: 'Make Italic',
    showInToolbar: true
  },
  underline: {
    title: 'Make underline',
    showInToolbar: true
  },
  clearFormat: {
    title: 'Clear format',
    showInToolbar: true
  },
  bulletList: {
    title: 'Bullet List',
    showInToolbar: true
  },
  orderedList: {
    title: 'Ordered list',
    showInToolbar: true
  },
  blockquote: {
    title: 'Blockquote',
    showInToolbar: true
  },
  image: {
    title: 'Image',
    showInToolbar: true
  },
  link: {
    title: 'Link',
    showInToolbar: true,
    options: {
      formatLink: defaultFormatLink
    }
  },
  fullScreen: {
    title: 'Full screen',
    showInToolbar: true
  },
  code: {
    title: 'Code',
    showInToolbar: true
  },
  horizontalRule: {
    title: 'Horizontal rule',
    showInToolbar: true
  },
  listItem: {
    title: 'List item',
    showInToolbar: true
  },
  keyboardShortcuts: {
    title: 'Keyboard Shortcuts',
    showInToolbar: true
  },
  clipboard: {
    options: {
      paste: true,
      copy: true,
      cut: true
    }
  }
};
exports.defaultControlsConfig = defaultControlsConfig;